import React from "react";
import AccessRoleMenu from "../components/menu/admin/AccessRoleMenu";

const ManajemenRole = () => {
  return <AccessRoleMenu />;
};
export default ManajemenRole;
